<template>
  <permission-gate
    v-slot="{ canEdit }"
    moduleKey="tipo-tratado"
  >
    <main-breadcrumb
      :items="items"
      showBackButton
    ></main-breadcrumb>
    <main-buttons-bar :align="'space-between'">
      <template #left>
        <custom-title>Listado de tipos de tratado</custom-title>
      </template>
      <template #right>
        <el-tooltip
          :disabled="canEdit"
          content="El usuario no posee permisos de edición"
          placement="top"
        >
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            :disabled="!canEdit"
            @click="newTipoTratado"
          >
            Nuevo tipo de tratado
          </el-button>
        </el-tooltip>
      </template>
    </main-buttons-bar>
    <tipo-tratado-filters></tipo-tratado-filters>
    <custom-table
      :requestApi="tipoTratadoStore.findAllTipoTratadosHTTP"
      pathEdit="/page/tipo-tratado/edit"
      paramId="Codigo"
      :data="tipoTratados"
      :columns="columns"
      :showDetailButton="false"
    />
  </permission-gate>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useTipoTratadoStore } from '../stores/tipo_tratado_store.js';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTable from '@/shared/components/custom_table.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import TipoTratadoFilters from './tipo_tratado_filters.vue';
import IconAdd from '~icons/mdi/add';
import PermissionGate from '@/shared/components/permission_gate.vue';

const router = useRouter();
const tipoTratadoStore = useTipoTratadoStore();
const { tipoTratados } = storeToRefs(tipoTratadoStore);

const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];
const columns = [
  { field: 'Descripcion', label: 'Descripcion', width: 480, sortable: true, isVisible: true },
];

function newTipoTratado() {
  tipoTratadoStore.resetTipoTratado();
  router.push('/page/tipo-tratado/edit');
}

onBeforeMount(async () => {
  tipoTratadoStore.resetFilters();
  await tipoTratadoStore.firstTipoTratados();
});
</script>

<style scoped></style>
